<template>
    <div
        :class="{ [`l-ss-c-filter-enum-${filter.name}`]: true, 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-enum">
        <c-label
            v-if="showTitle"
            :label="filterLabel"/>
        <span
            v-if="showSearchField"
            class="l-ss-c-filter-enum-search-wrap">
            <input
                v-model="localSearch"
                class="l-ss-c-input l-ss-c-filter-enum-search-input"
                :placeholder="$t('filters.enumSearch')"
                autofocus>
        </span>
        <div class="l-ss-c-filter-enum-group-wrapper">
            <!--            <div-->
            <!--                v-for="group in groups"-->
            <!--                :key="`enum-filter-${group.letter}-${group.options.length}`"-->
            <!--                class="l-ss-c-filter-enum-group"-->
            <!--                :class="{ ['l-ss-c-filter-enum-group-spacing']: showSearchField }">-->
            <!--                <div-->
            <!--                    v-for="option in group.options"-->
            <!--                    class="l-ss-c-filter-enum-option"-->
            <!--                    :class="{ 'l-ss-c-filter-enum-option-is-active': isChecked(option.id) }"-->
            <!--                    :key="`filter-${option.id}-${isChecked(option.id)}`"-->
            <!--                    @click="onToggle(option.id)">-->
            <!--                    <span class="l-ss-c-filter-enum-option-label">{{ option.name }}</span>-->
            <!--                    <span-->
            <!--                        class="l-ss-c-filter-enum-option-counter"-->
            <!--                        v-if="option.hits">{{ option.hits }}</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <div
                v-for="(option, index) in filterOptionsSort"
                class="l-ss-c-filter-enum-option"
                :class="{ 'l-ss-c-filter-enum-option-is-active': isChecked(option.id) }"
                :key="`filter-${option.id}-${isChecked(option.id)}`"
                @click="onToggle($event, option, index)">
                <span class="l-ss-c-filter-enum-option-label">{{ getNumberByString(option.name) }}</span>
                <span
                    class="l-ss-c-filter-enum-option-counter"
                    v-if="option.hits">{{ option.hits }}</span>
            </div>
        </div>
        <div
            v-if="hasShowMore"
            class="l-ss-c-navigation-list-item-actions">
            <button
                v-if="showMore"
                class="l-ss-c-button"
                @click="() => showMore=false">
                {{ $t('navigation.showLess') }}
            </button>
            <button
                v-else
                class="l-ss-c-button"
                @click="() => showMore=true">
                {{ $t('navigation.showMore') }}
            </button>
        </div>
        <button
            v-if="isActiveTopFiltersPosition && isShort"
            class="l-ss-c-filters-save-button l-ss-c-button"
            @click="$emit('close-filter')">
            {{ $t('filters.applyPrice') }}
        </button>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';

    const MIN_ITEMS_COUNT_FOR_SHOW_MORE = 3;
    const MIN_ITEMS_COUNT_FOR_SEARCH_FIELD = 5;

    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        props: {},
        data() {
            return {
                values: [],
                showMore: false,
                localSearch: '',
                trackParams: [],
            };
        },
        computed: {
            isSortByAlphabet() {
                return this.filter.name === 'category' && this.$configuration.sortCategoriesАlphabetically;
            },

            filterOptions() {
                return this.filter.options.filter(item => item.name.toLowerCase().includes(this.localSearch.trim().toLowerCase()));
            },

            filterOptionsSort() {
                return !this.isSortByAlphabet
                    ? this.filterOptions
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    : this.filterOptions.sort((a, b) => a.name.localeCompare(b.name));
            },

            hasShowMore() {
                return !this.forceShowAll && this.filter.options.length >= MIN_ITEMS_COUNT_FOR_SHOW_MORE;
            },
            optionsIndex() {
                return this.filter.options.slice(0).map(item => ({
                    ...item,
                    searchIndex: item.name.toLowerCase(),
                    firstLetter: item.name.charAt(0).toLowerCase(),
                }));
            },
            groupsListWithIndex() {
                const options = this.optionsIndex;
                const groups = options.reduce((memo, item) => {
                    memo[item.firstLetter] = memo[item.firstLetter] || [];
                    memo[item.firstLetter].push(item);
                    return memo;
                }, {});

                return Object.keys(groups).map(letter => ({
                    letter,
                    options: groups[letter],
                })).sort((left, right) => left.letter - right.letter);
            },
            groups() {
                const groups = this.groupsListWithIndex;
                const searchString = String(this.localSearch).trim().toLowerCase();

                return searchString
                    ? groups.map(({ options, ...other }) => {
                        return {
                            ...other,
                            options: options.filter(item => item.searchIndex.includes(searchString)),
                        };
                    }).filter(group => !!group.options.length)
                    : groups;
            },
            showSearchField() {
                return this.localSearch || this.optionsIndex.length > MIN_ITEMS_COUNT_FOR_SEARCH_FIELD;
            },
        },
        watch: {
            filterValue: {
                handler(value) {
                    if (value && value.options) {
                        this.values = value.options.slice(0);
                        this.values = Array.from(new Set(this.values));
                    } else {
                        this.values = [];
                    }
                },
                immediate: true,
            },
        },
        mounted() {
            const options = this.options || [];
            if (this.values.length && !this.values.every(optionId => options.find(item => item.id === optionId))) {
                this.showMore = true;
            }
        },
        methods: {
            isChecked(optionId) {
                return this.values.includes(optionId);
            },
            onToggle(event, value, index) {
                const checked = this.isChecked(value.id);
                const values = this.values.slice(0);
                if (checked) {
                    values.splice(values.indexOf(value.id), 1);
                    this.trackParams.splice(this.trackParams.indexOf(value.id), 1);
                } else {
                    values.push(value.id);

                    const trackValue = {
                        ...value,
                        pos: index + 1,
                    };

                    this.trackParams.push(trackValue);
                }
                if (values.length) {
                    this.onChange({
                        condition: 'in',
                        options: values.slice(0),
                    });

                    this.onFilterClick(event, this.trackParams);
                } else {
                    this.onChange();
                    this.onFilterClick(event);
                }
            },
        },
    };
</script>
